import {Component, OnDestroy, OnInit} from '@angular/core';
import {SurveyModule} from "survey-angular-ui";
import {firstValueFrom} from "rxjs";
import {SurveyTemplate} from "@allaihealth/survey";
import {environment} from "../../../environments/environment";
import {SurveyService} from "../../services/survey.service";
import {HttpClient} from "@angular/common/http";
import {SurveyModel} from "survey-core";
import {CommonModules} from "dci-service-shared";

@Component({
	selector: 'app-csat',
	imports: [SurveyModule],
	templateUrl: './csat.component.html',
	styleUrl: './csat.component.scss'
})
export class CsatComponent implements OnInit, OnDestroy {
	/** The currently displayed SurveyJS survey */
	model:SurveyModel;

	constructor(private http:HttpClient,
	            private surveyService:SurveyService) {
	}

	async ngOnInit() {
		try {
			this.model = this.surveyService.newSurvey();

			this.model.beginLoading();

			console.info(`Starting load of csat questions...`);

			const template = await firstValueFrom(
				this.http.get<SurveyTemplate>(`${environment.apiUrl}/module/${CommonModules.CSAT}`));

			this.model.fromJSON(template);

			this.model.showCompletePage = true;

			this.model.onComplete.add(() => this.onComplete());

			this.model.endLoading();
		} catch(e) {
			console.error("Failed to load survey", e);
			this.surveyService.redirectToErrorPage();
		}
	}

	ngOnDestroy():void {
		this.model.dispose();
	}

	private async onComplete() {

		await firstValueFrom(this.http.put<any>(`${environment.apiUrl}/dci/${this.surveyService.surveyId}/csat`, this.model.data));

	}
}
